// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2BhSk","header":"MessagesList_header__3TzDY","chat":"MessagesList_chat__1vx7-"};